import { secureDelete, secureGet, securePost, securePut } from "../../Config/ApiConfig";
import { removeNullUndefinedWithReduce } from "../../Utils/javascript";

export const getMessages = async ({ page, size, conversation_id }) => {
    const { data } = await secureGet(`/conversations/${conversation_id}/messages?sort_by=sent_at&sort_direction=desc&page=` + page + '&per_page=' + size)
    return data;
};

export const getConversations = async ({ page, size, agent_id, filters = {}, search_string }) => {
    let url = `/agents/${agent_id}/conversations?sort_by=created_at&sort_direction=desc&page=` + page + '&per_page=' + size + (filters ? `&filters=${JSON.stringify(removeNullUndefinedWithReduce(filters))}` : '')
        + (search_string ? `&search_string=${search_string}` : '');
    const { data } = await secureGet(url);
    return data;
};

export const getAgents = async ({ page, size, search }) => {
    const { data } = await secureGet(`/agents?page=${page}&per_page=${size}${search ? "&search_string=" + search : ''}`);
    return data;
};

export const updateContact = (id, body) => {
    const { data } = securePut(`/contacts/${id}`, body);
    return data;
}

export const deleteConversation = (id) => {
    const { data } = secureDelete(`/conversations/${id}`);
    return data;
}

export const sendMessage = async (conversation_id, body) => {
    const { data } = await securePost(`/conversations/${conversation_id}/messages`, body);
    return data;
};

export const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append('file', file);

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    };

    const { data } = await securePost('/file-uploads', formData, config);
    return data;
};
